// Copyright (C) AirWorks Solutions, Inc - All Rights Reserved
// DO NOT REDISTRIBUTE
// UNAUTHORIZED COPYING OF THIS FILE, ANY PART OR WHOLE, VIA ANY MEDIUM IS STRICTLY PROHIBITED
// PROPRIETARY AND CONFIDENTIAL

const styles = (theme: any) => ({
  root: {
    backgroundColor: '#797979',
    zIndex: 1,
    color: '#fff',
    width: 20,
    height: 20,
    display: 'flex',
    borderRadius: '50%',
    justifyContent: 'center',
    alignItems: 'center',
  },
  stepActive: {
    border: '3px solid #08D38F',
    backgroundColor: '#18216D',
    boxShadow: '0 4px 10px 0 rgba(0,0,0,.25)',
  },
  stepCompleted: {
    border: '3px solid #08D38F',
    backgroundColor:
      '#08D38F',
    '&::before': {
      content: '"✔"',
      color: '#000',
      fontSize: '15px',
      marginRight: '1px',
    },
  },
});

export default styles;
